import React, { useCallback, useState, useEffect, useContext } from 'react';
import { Box, Checkbox } from '@mui/material';
import PropTypes from 'prop-types';
import { usePolicyRenewalUtils } from '../../utils';
import { useAuthorization } from 'hooks';
import InsuranceDataContext from 'features/insuranceDocument/stepper/insuranceDataContext';
import AuthorizationCodes from 'features/common/constants/authorizationCodes';

const PolicyRenewalItemSelectionComponent = ({ item }) => {
  const { documentTypeId, documentStateId } = useContext(InsuranceDataContext);
  const hasRightToEditRenewal = useAuthorization(AuthorizationCodes.hasRightToEditRenewal, documentTypeId, documentStateId);
  const {
    documentId: renewalDocumentId,
    renewalPolicyDocument: { documentNumber, quotationsDate, sentToClientDate }
  } = item;

  const { retrieveSelectedIds, updateAvailableItem, watchSelections } = usePolicyRenewalUtils();

  const [selected, setSelected] = useState(false);

  // #region Selection

  const handleSelect = useCallback(
    () =>
      updateAvailableItem({
        renewalDocumentId,
        selected: !selected // 'selected' will be updated via the 'selectedIdsSubscription' set up below
      }),
    [selected, renewalDocumentId, updateAvailableItem]
  );

  useEffect(() => {
    updateAvailableItem({
      renewalDocumentId,
      documentNumber,
      quotationsDate,
      sentToClientDate
    });
  }, [renewalDocumentId, documentNumber, quotationsDate, sentToClientDate, updateAvailableItem]);

  useEffect(() => {
    const selectedIdsSubscription = watchSelections(selections =>
      setSelected(selections.some(x => x.renewalDocumentId === renewalDocumentId))
    );

    return () => {
      selectedIdsSubscription.unsubscribe();
    };
  }, [watchSelections, renewalDocumentId]);

  useEffect(() => {
    const selectedIds = retrieveSelectedIds();
    setSelected(selectedIds.includes(renewalDocumentId));
  }, [renewalDocumentId, retrieveSelectedIds]);

  // #endregion

  return (
    <Box sx={{ position: 'absolute' }}>
      <Checkbox id={`offer_selected_${renewalDocumentId}`} checked={selected} onChange={handleSelect} disabled={!hasRightToEditRenewal} />
    </Box>
  );
};

PolicyRenewalItemSelectionComponent.propTypes = {
  item: PropTypes.object.isRequired
};

export default PolicyRenewalItemSelectionComponent;
